import ContentLoader from 'react-content-loader'

import useContentLoaderColors from '@/lib/theme/useContentLoaderColors'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './MenuItemPlaceHolder.module.scss'

export default memo(function MenuItemPlaceHolder() {
  const [backgroundColor, foregroundColor] = useContentLoaderColors()
  return (
    <div className={style.MenuItem} role='alert'>
      <VisuallyHidden>Loading the menu item list...</VisuallyHidden>
      <ContentLoader
        role='progressbar'
        speed={2}
        width={'100%'}
        height={'100%'}
        viewBox='0 0 350 200'
        backgroundColor={backgroundColor}
        foregroundColor={foregroundColor}
      >
        <rect x='0' y='0' rx='4' ry='4' width='165' height='30' />
        <rect x='0' y='40' rx='4' ry='4' width='165' height='30' />
        <rect x='0' y='170' rx='4' ry='4' width='165' height='30' />
        <rect x='185' y='0' rx='4' ry='4' width='350' height='200' />
      </ContentLoader>
    </div>
  )
})
